import { apiFetch } from './client'
import type { BedState } from './hospitals'

/** Partial bed-inventory update. Only the fields the admin changed are sent
 * (matches the backend's `exclude_unset`). `if_updated_at` is the optimistic
 * concurrency token — the `updated_at` the client last saw. */
export type BedPatchBody = Partial<{
  icu_total: number
  icu_free: number
  general_total: number
  general_free: number
  private_total: number
  private_free: number
  executive_total: number
  executive_free: number
  maternity_total: number
  maternity_free: number
  emergency_status: 'open' | 'divert' | 'closed'
  ambulance_available: boolean
}> & { if_updated_at: string }

/** PATCH /api/v1/admin/hospitals/{id}/beds — returns the new bed state.
 * Throws ApiError on 409 (`concurrent_modification`), 422 (`invalid_bed_counts`),
 * 401, or 5xx — the caller branches on `error.code`. */
export async function patchBeds(
  token: string | null,
  hospitalId: string,
  body: BedPatchBody,
): Promise<BedState> {
  const res = await apiFetch<{ data: { beds: BedState } }>(
    `/api/v1/admin/hospitals/${hospitalId}/beds`,
    { token, method: 'PATCH', body },
  )
  return res.data.beds
}
